import React, { useContext } from"react";
import {
 AppBar,
 Toolbar,
 Typography,
 IconButton,
 Box,
 Drawer,
 List,
 ListItem,
 ListItemText,
 useMediaQuery,
} from"@mui/material";
import { Link, useLocation, useNavigate } from"react-router-dom";
import { Menu as MenuIcon } from"@mui/icons-material";
import { useTheme } from"@mui/material/styles";
import { UserContext } from "./UserContext";
import { useTenant } from "../Context/TenantContext";

const Navbar = () => {
 const navigate = useNavigate();
 const [drawerOpen, setDrawerOpen] = React.useState(false);
 const theme = useTheme();
 const location = useLocation();
 const isMobile = useMediaQuery(theme.breakpoints.down("md"));
 const { user } = useContext(UserContext);
 const { getLogoUrl, getCollegeName, isWhiteLabelEnabled } = useTenant();

 const handleDrawerToggle = () => {
 setDrawerOpen(!drawerOpen);
 };

 const isLoginPage = location.pathname === "/" ||
                   location.pathname === "/login" ||
                   location.pathname === "/student/login" || 
                   location.pathname === "/admin/login" || 
                   location.pathname === "/collegelogin" ||
                   location.pathname === "/register" ||
                   location.pathname === "/forgot-password" ||
                   location.pathname === "/usertype" ||
                   location.pathname === "/college-intro" ||
                   location.pathname === "/tsg-collab" ||
                   location.pathname === "/student-intro" ||
                   location.pathname === "/tsg-product-engg";

 const { tenant } = useTenant();
 // Full-screen Super Admin content workspace owns its own sticky header.
 const isFullScreenWorkspace = location.pathname.startsWith('/superadmin/elite-technologies/content/');
 if (tenant || isLoginPage || isFullScreenWorkspace || location.pathname.startsWith('/college') || location.pathname.startsWith('/student') || location.pathname.startsWith('/bootcamp')) {
   return null;
 }

 return (
 <>
    <AppBar position="sticky" elevation={0} sx={{ 
    backgroundColor:"#6B21A8", 
    borderBottom:"1px solid rgba(255, 255, 255, 0.1)",
    top: 0,
    zIndex: 1100
  }}>
<Toolbar sx={{ display:"flex", justifyContent:"space-between", py: 1 }}>
{/* ✅ Modified: Logo & Name do NOT redirect */}
<Box
sx={{
display:"flex",
alignItems:"center",
textDecoration:"none",
color:"white",
cursor:"default", // show it's not clickable
}}
>
<img
src={getLogoUrl()}
alt={getCollegeName()}
onError={(e) => {
  if (!e.target.dataset.tried) {
    e.target.dataset.tried = "true";
    e.target.src = "/logo192.png"; // Fallback to default logo
  }
}}
style={{
width: isMobile ? 35 : 45,
height: isMobile ? 35 : 45,
marginRight: 10,
borderRadius:"12px",
objectFit:"contain",
backgroundColor:"#fff",
padding: 2
}
}
/>
<Typography variant={isMobile ? "body1" : "h6"} sx={{ color:"white", fontWeight:"800", letterSpacing: "-1px", fontFamily: "'Poppins', sans-serif" }}>
      THE SKILL GENIE
    </Typography>
    {!isMobile && (
      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.6)", ml: 2, fontWeight: 600, borderLeft: "1px solid rgba(255,255,255,0.2)", pl: 2 }}>
        Learn. Build. Get Hired.
      </Typography>
    )}
 </Box>

 {/* Right: Menu */}
 {isMobile ? (
 <IconButton edge="end" sx={{ color:"white" }} onClick={handleDrawerToggle}>
 <MenuIcon />
 </IconButton>
 ) : (
        <Box sx={{ display:"flex", gap: 4, alignItems:"center" }}>
          {/* Navigation Items */}
          {[].map((item) => (
            <Typography 
              key={item.label}
              variant="body2" 
              onClick={() => navigate(item.path)}
              sx={{ 
                color: "rgba(255,255,255,0.8)", 
                fontWeight: 700, 
                cursor: "pointer",
                textTransform: "uppercase",
                letterSpacing: "1px",
                fontSize: "12px",
                position: "relative",
                transition: "all 0.3s ease",
                '&:hover': { color: "white" },
                '&:after': {
                  content: '""',
                  position: 'absolute',
                  width: '0%',
                  height: '2px',
                  bottom: -4,
                  left: 0,
                  backgroundColor: 'white',
                  transition: 'width 0.3s ease'
                },
                '&:hover:after': { width: '100%' }
              }}
            >
              {item.label}
            </Typography>
          ))}

          {(!user || Object.keys(user).length === 0) && !isLoginPage && (
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Link to="/login" style={{ textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ color: 'white', fontWeight: 700, cursor: 'pointer', fontSize: '14px' }}>
                  Login
                </Typography>
              </Link>
              <Link to="/usertype" style={{ textDecoration: 'none' }}>
                <button className="px-8 py-3 bg-white text-black rounded-full font-bold text-sm hover:scale-105 transition-all">
                  Get Started
                </button>
              </Link>
            </Box>
          )}
        </Box>
 )}
 </Toolbar>
 </AppBar>

 {/* Mobile Drawer */}
 {isMobile && (
 <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerToggle} PaperProps={{ sx: { width: "80%", maxWidth: 300, backgroundColor: "#0A0A0B", color: "white" } }}>
<Box sx={{ p: 3 }} role="presentation">
 <Typography variant="h6" sx={{ color: "white", fontWeight: 800, mb: 1 }}>
   THE SKILL GENIE
 </Typography>
 <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)", mb: 4, display: 'block', fontWeight: 600 }}>
   Learn. Build. Get Hired.
 </Typography>
 <List>
   {[].map((item) => (
     <ListItem 
       button 
       key={item.label} 
       onClick={() => { navigate(item.path); handleDrawerToggle(); }}
       sx={{ borderRadius: 2, mb: 1, '&:hover': { backgroundColor: 'rgba(255,255,255,0.05)' } }}
     >
       <ListItemText 
         primary={item.label} 
         primaryTypographyProps={{ fontWeight: 600, color: "rgba(255,255,255,0.7)", fontSize: "14px" }} 
       />
     </ListItem>
   ))}
   <Box sx={{ mt: 4, pt: 4, borderTop: "1px solid rgba(255,255,255,0.05)" }}>
     {!user || Object.keys(user).length === 0 ? (
         !isLoginPage && (
           <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
             <Link to="/login" style={{ textDecoration: 'none' }} onClick={handleDrawerToggle}>
               <button className="w-full py-4 border border-white/20 text-white rounded-xl font-bold">
                 Login
               </button>
             </Link>
             <Link to="/usertype" style={{ textDecoration: 'none' }} onClick={handleDrawerToggle}>
               <button className="w-full py-4 bg-white text-black rounded-xl font-bold">
                 Get Started
               </button>
             </Link>
           </Box>
         )
     ) : null}
   </Box>
 </List>
</Box>
</Drawer>
 )}
 </>
 );
};

export default Navbar;



